<template>
  <div id="supply-city-rank" style="height: 150px"></div>
</template>
<script>
import Charts from '@jiaminghi/charts'
export default {
  data() {
    return {
      option: {
        title: { show: false },
        grid: { top: 0, left: 0, right: 0, bottom: 24 },
        legend: {
          data: [
            {
              name: '2023',
              color: '#da3792',
            },
            {
              name: '2024',
              color: '#37da92',
            },
          ],
          textStyle: {
            fill: '#9cd9fc',
          },
          top: 15,
          right: 0,
        },
        xAxis: {
          name: '',
          data: ['上海', '深圳', '北京', '杭州', '苏州', '广州', '合肥'],
          axisLabel: {
            style: {
              fill: '#cfcfcf',
            },
          },
        },
        yAxis: {
          name: '',
          data: 'value',
          min: 1000,
          max: 4000,
          axisLine: { show: false },
          axisLabel: { show: false },
          axisTick: { show: false },
          splitLine: {
            style: { stroke: '#3f3f3f' },
          },
        },
        series: [
          {
            name: '2023',
            stack: 'a',
            data: [3050, 2611, 2940, 2749, 2390, 2195, 1953],
            type: 'bar',
            shapeType: 'leftEchelon',
            label: {
              show: true,
              formatter: '{value}',
              style: { fill: '#ccc' },
            },
            gradient: {
              color: ['rgba(0xda,0x37,0x92,.75)', 'rgba(0xe3,0x67,0x90,.3)'],
            },
          },
          {
            name: '2024',
            data: [2968, 3053, 3502, 2950, 2086, 1609, 1960],
            type: 'bar',
            shapeType: 'rightEchelon',
            label: {
              show: true,
              formatter: '{value}',
              style: { fill: '#ccc' },
            },
            gradient: {
              color: ['rgba(0x37,0xda,0x92,.75)', 'rgba(0x67,0xe3,0x90,.3)'],
            },
          },
        ],
      },
    }
  },
  mounted() {
    const container = document.getElementById('supply-city-rank')
    const myChart = new Charts(container)
    myChart.setOption(this.option)
  },
}
</script>


// WEBPACK FOOTER //
// src/components/screen38496/market-zone/supply-city-rank.vue